import { useContext } from 'react';
import { BookingSlotsContext } from '../helpers/context';

export const useBookingSlots = () => {
	const context = useContext(BookingSlotsContext);
	if (!context) {
		throw new Error(
			'useBookingSlots must be used within an BookingSlotsProvider',
		);
	}
	return context;
};
